<div
    #UniSearchWrapper
    class="universal-search-wrapper d-flex flex-fill align-items-center"
    matAutocompleteOrigin
    #origin="matAutocompleteOrigin">
    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="keyword-dropdown flex-shrink-0">
        <mat-select [formControl]="keywordFilter" [panelWidth]="null">
            <mat-option [value]="''">All</mat-option>
            @for (keyword of keywordList; track keyword) {
                <mat-option
                    *hideForRoles="keyword.denyRoles ?? []"
                    [value]="keyword.term"
                    [matTooltip]="keyword.tooltip"
                    matTooltipPosition="left">
                    {{ keyword.displayText }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <div class="search-divider"></div>
    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="uni-search d-flex flex-fill">
        <mat-icon matPrefix>search</mat-icon>
        <input
            title="Search"
            matInput
            placeholder="Search in Arcus"
            [formControl]="searchText"
            [matAutocomplete]="searchAuto"
            [matAutocompleteConnectedTo]="origin" />
        @if (searchText.value) {
            <button matIconSuffix mat-icon-button aria-label="Clear" (click)="closePanel()">
                <mat-icon>close</mat-icon>
            </button>
        }
        <mat-autocomplete
            #searchAuto="matAutocomplete"
            [displayWith]="searchItemDisplayFn"
            (optionSelected)="onUniversalSearchChange()"
            autoActiveFirstOption
            class="uni-search-autocomplete-panel">
            @for (item of filteredSearchItems(); track `${item.DocType}-${item.ID}`) {
                <mat-option [value]="item" class="universal-search-option">
                    @switch (item.DocType) {
                        @case ("load") {
                            <load-result
                                [item]="item"
                                [searchTerm]="searchTextSignal()"
                                (shortcutClick)="closePanel()"></load-result>
                        }
                        @case ("order") {
                            <order-result
                                [item]="item"
                                [searchTerm]="searchTextSignal()"
                                (shortcutClick)="closePanel()"></order-result>
                        }
                        @case ("customer") {
                            <customer-result
                                [item]="item"
                                [searchTerm]="searchTextSignal()"
                                (shortcutClick)="closePanel()"></customer-result>
                        }
                        @case ("carrier") {
                            <carrier-result
                                [item]="item"
                                [searchTerm]="searchTextSignal()"
                                (shortcutClick)="closePanel()"></carrier-result>
                        }
                        @case ("branch_location") {
                            <location-result
                                [item]="item"
                                [searchTerm]="searchTextSignal()"
                                (shortcutClick)="closePanel()"></location-result>
                        }
                        @case ("referencenumber") {
                            <order-result
                                [item]="item"
                                [searchTerm]="searchTextSignal()"
                                (shortcutClick)="closePanel()"></order-result>
                        }
                    }
                    <mat-divider></mat-divider>
                </mat-option>
            } @empty {
                @if (hasSearched()) {
                    <mat-option disabled class="no-results-option">No results found</mat-option>
                }
            }
        </mat-autocomplete>
    </mat-form-field>
</div>
